<template>
  <div class="address-block-wrap emb-card pa-4">
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    </div>
    <h4 class="mb-6">{{addressSection.Title}}</h4>
    <v-layout row wrap>
      <v-flex xs12 sm6 md6 lg5 xl5>
        <h5>{{addressSection.Billing_Address_Title}}</h5>
        <div class="emb-card pa-4">
          <span style=" display:flex;justify-content:space-between;">
            <!-- <h5>{{addressSection.Billing_Address_Title}}</h5> -->
            <router-link
              v-if="visible=='false'"
              :to="{name: 'EditAddress', query: {type: 'address',Id:'' }}"
            >
              <v-btn class="accent">{{addressSection.Add_New_Address_Label}}</v-btn>
            </router-link>
          </span>
          <div v-if="visible=='false'">
            <address class="mb-6">
              <p>{{addressSection.Empty_Address_Label}}</p>
            </address>
            <!-- <router-link :to="{name: 'EditAddress', query: {type: 'address',Id:'' }}">
              <v-btn class="accent">{{addressSection.Add_New_Address_Label}}</v-btn>
            </router-link>-->
          </div>
          <div v-else v-for="(item,index) in billingAddressData " :key="index">
            <address class="mb-6">
              <p>{{item.keyword4}}</p>
              <p>{{item.keyword3}}</p>
              <p>{{item.keyword5}}</p>
            </address>
            <router-link :to="{name: 'EditAddress', query: {type: 'address',Id:item.id}}">
              <v-btn class="accent mx-0">{{addressSection.Edit_Button_Label}}</v-btn>
            </router-link>
          </div>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md6 lg6 xl5>
        <h5>{{addressSection.Shipping_Address_Title}}</h5>
        <div class="emb-card pa-4">
          <!-- <h5>{{addressSection.Shipping_Address_Title}}</h5> -->
          <router-link :to="{name: 'EditAddress', query: {type: 'ship-address',Id:'' }}">
            <v-btn class="accent">{{addressSection.Add_New_Address_Label}}</v-btn>
          </router-link>
          <v-flex xs12 sm12 md12 lg12 xl5 v-for="(item,index) in shippingAddressData " :key="index">
            <div class="emb-card pa-4">
              <!-- <v-chip  class="ma-2" label >{{item.keyword15}}</v-chip> -->
            <span style="display:flex;justify-content:space-between">
              <b>{{item.keyword15}} </b>
              <p v-if="item.bool1==false">
                <u>
                  <a
                    href="#"
                    classs="address-box"
                    @click.prevent="setDefaultAddress(item,item.id)"
                  >{{addressSection.Set_as_default_label}}</a>
                </u>
              </p>
              <p v-else class="orange--text">{{addressSection.Default_Shipping_Address_Title}}</p>
            </span>
               <address>
                <p>{{item.keyword4}}</p>
                <p>{{item.keyword3}}</p>
                <p>{{item.keyword5}}</p>
              </address>
              <span style="display:flex;justify-content:space-between">
                <router-link :to="{name: 'EditAddress', query: {type: 'ship-address',Id:item.id}}">
                  <v-btn class="accent">{{addressSection.Edit_Button_Label}}</v-btn>
                  <!-- <i class="fa fa-pencil icons"></i> -->
                </router-link>

                <!-- <v-btn
                  v-if="item.bool1==true"
                  class="accent address-box"
                  :disabled="item.bool1"
                >{{addressSection.Delete_Label}}</v-btn>-->
                <v-btn
                  :disabled="item.bool1"
                  class="accent address-box"
                  @click.prevent="deleteDetails('Shipping Address',item.id)"
                >{{addressSection.Delete_Label}}</v-btn>
              </span>
              <!-- <v-btn     class="accent address-box"  @click.prevent="deleteDetails('Shipping Address',item.id)">{{addressSection.Delete_Label}}</v-btn>  -->
            </div>
          </v-flex>
          <router-link
            v-if="fromPage &&shippingAddressData.length"
            @click.native="removefromPage()"
            :to="{path: '/checkout/payment'}"
          >
            <v-btn class="accent mx-0">{{"Back to checkout"}}</v-btn>
          </router-link>
        </div>
        <!-- <div v-if="fromPage==='checkout'"> -->

        <!-- </div> -->
      </v-flex>
    </v-layout>
  </div>
</template>
   
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../services/utils/cms-helper";
// import "../../assets/css/commonstylesheet.css";
import VueMoment from "vue-moment";
// import router from "../../router";
import moment from "moment-timezone";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(VueMoment, {
  moment,
});
export default {
  computed: {
    ...mapGetters(["rtlLayout", "selectedLocale"]),
    fromPage() {
      try {
        var flag = localStorage.getItem("fromPage");
        if (flag != null && flag != undefined && flag === "checkout") {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
  },
  components: {
    Loading,
  },
  data() {
    return {
      cmsRequestFunctions: null,
      // fromPage: false,
      addressSection: "",
      streetNameBill: "",
      shippingAddressData: [],
      check1: "",
      check2: "",
      bool: "",
      billingAddressData: "",
      stateBill: "",
      zipcodeBill: "",
      countryBill: "",
      streetNameSh: "",
      stateSh: "",
      zipcodeSh: "",
      countrySh: "",
      userName: "",
      userData: "",
      result: [],
      id: "",
      direction: "",
      shows: "",
      visible: "",
      checkedVal: "",
      loginDetails: "",
      len: "",
      valid: false,
      isLoading: false,
      fullPage: true,
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getData();
    let validation = localStorage.getItem("validationItems");
    if (!validation) {
      this.cmsRequestFunctions.getValidationMsgs();
    }
    this.readShippingAddress();
    this.readBillingAddress();
    var fromPage = this.$route.query.to ? this.$route.query.to : "" || "";
    if (fromPage === "checkout") {
      localStorage.setItem("fromPage", fromPage);
      this.$snotify.success(
        this.cmsRequestFunctions.getValidationMsgByCode("M040"),
        {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
          showProgressBar: false,
        }
      );
    }
  },
  watch: {
    selectedLocale: function () {
      this.getData();
      this.readShippingAddress();
      this.readBillingAddress();
    },
  },
  methods: {
    saveDetails() {
      this.$refs.form.validate();
      if (this.valid == true) {
        // this.$store.dispatch("addUserDetails", this.userInfo);
      }
    },
    getData() {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "13 Address/13 Address/13 Address.ftl",
        lang: language,
        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var addressArea = self.cmsRequestFunctions.pluck(
              "Address_Section",
              res.area_List
            );
            self.addressSection = self.cmsRequestFunctions.getAllMapData(
              addressArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
      self.direction = localStorage.getItem("direction");
    },
    readShippingAddress: async function () {
      var self = this;
      try {
        self.isLoading = true;
        var user = localStorage.getItem("embryo");
        self.userData = JSON.parse(user);
        self.loginDetails = self.userData.user_data;
        var userName = self.loginDetails.loginId;

        var filterValue =
          "type='Shipping Address' AND keyword12='" + userName + "'";
        var allData = await self.cmsRequestFunctions.getDbDataTableValue(
          filterValue,
          "date1"
        );
        if (
          allData != undefined &&
          allData.data != undefined &&
          allData.status == 200
        ) {
          self.shippingAddressData = [];
          var tempArray = allData.data.data;
          self.len = tempArray.length;
          if (self.len > 1) {
            for (const iterator of tempArray) {
              if (iterator.bool1 == true) {
                self.shippingAddressData.push(iterator);
              }
            }
            for (const iterator of tempArray) {
              if (iterator.bool1 == false) {
                self.shippingAddressData.push(iterator);
              }
            }
          } else {
            if (self.len == 1) {
              for (const iterator of tempArray) {
                iterator.bool1 = true;
              }
            }
            self.shippingAddressData = tempArray;
          }
          self.isLoading = false;
        } else {
          console.log("error:", allData);
          self.isLoading = false;
        }
      } catch (error) {
        self.isLoading = false;
        console.log("error:", error);
      }
    },
    deleteDetails: async function (addressType, addressId) {
      var self = this;
      try {
        self.isLoading = true;
        var allData = await self.cmsRequestFunctions.deleteDbDataTableValue(
          addressId
        );
        if (
          allData != undefined &&
          allData.data != undefined &&
          allData.status == 200
        ) {
          this.$snotify.success(
            this.cmsRequestFunctions.getValidationMsgByCode("M023"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          setTimeout(() => {
            self.readShippingAddress();
          }, 600);
        } else {
          console.log("error:", allData);
        }
        // self.isLoading = false;
      } catch (error) {
        console.log(error);
        self.isLoading = false;
      }

      //location.reload();
    },
    setDefaultAddress: async function (item, Id) {
      var self = this;
      try {
        self.isLoading = true;
        var prevAddress = self.shippingAddressData.find(function (element) {
          return element.bool1 == true;
        });
        var sendingRequestup = {
          type: "Shipping Address",
          bool1: true,
        };
        var removeReq = {
          type: "Shipping Address",
          bool1: false,
        };
        if (prevAddress !== undefined && prevAddress.id != undefined) {
          await self.cmsRequestFunctions.cmsFormUpdateData(
            removeReq,
            prevAddress.id
          );
        }

        try {
          // let insertID = await responseObject2.data;
          // console.log(insertID);
          let responseObject = await this.cmsRequestFunctions.cmsFormUpdateData(
            sendingRequestup,
            Id
          );
          try {
            let insertIdUpdated = responseObject.data;
            console.log(insertIdUpdated);
            self.$snotify.success(
              self.cmsRequestFunctions.getValidationMsgByCode("M025"),
              {
                closeOnClick: false,
                pauseOnHover: false,
                timeout: 1000,
                showProgressBar: false,
              }
            );
            setTimeout(() => {
              self.readShippingAddress();
            }, 600);
          } catch (error) {
            console.log(error);
            self.isLoading = false;
          }
        } catch (error) {
          console.log(error);
          self.isLoading = false;
        }
        // self.isLoading = false;
      } catch (error) {
        console.log(error);
        self.isLoading = false;
      }
    },
    readBillingAddress: async function () {
      var self = this;
      try {
        self.isLoading = true;
        var user = localStorage.getItem("embryo");
        self.userData = JSON.parse(user);
        self.loginDetails = self.userData.user_data;
        // console.log(self.loginDetails);
        var userName = self.loginDetails.loginId;
        //console.log('userName',userName);
        var filterValue =
          "type='Billing Address' AND keyword12='" + userName + "'";
        var allData = await this.cmsRequestFunctions.getDbDataTableValue(
          filterValue,
          "date1"
        );
        if (
          allData != undefined &&
          allData.data != undefined &&
          allData.status == 200
        ) {
          self.visible = "true";
          self.billingAddressData = allData.data.data;
          self.billingAddressData = [...self.billingAddressData];
          console.log("billingAddressData:", self.billingAddressData);
          self.isLoading = false;
        } else {
          self.visible = "false";
          self.isLoading = false;
          console.log("error:", allData);
        }
      } catch (error) {
        console.log(error);
        self.isLoading = false;
      }
    },
    removefromPage() {
      localStorage.removeItem("fromPage");
    },
  },
};
</script>

